import type {ViewerContext} from '@wix/wixstores-client-storefront-common';

type InitializeSuggestedCurrencyAutoSwitchToastParams = Parameters<
  ViewerContext['initializeSuggestedCurrencyAutoSwitchToast']
>[0];

const initializedPageKeys = new Set<string>();

export function initializeSuggestedCurrencyAutoSwitchToastOnce({
  viewerContext,
  pageKey,
  params,
}: {
  viewerContext: ViewerContext;
  pageKey: string;
  params: InitializeSuggestedCurrencyAutoSwitchToastParams;
}): void {
  if (initializedPageKeys.has(pageKey)) {
    return;
  }

  initializedPageKeys.add(pageKey);
  void viewerContext.initializeSuggestedCurrencyAutoSwitchToast(params);
}

export function resetSuggestedCurrencyAutoSwitchToastInitializationForTests(): void {
  initializedPageKeys.clear();
}
